import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemChecklist, BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function SystemOverview() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-144" data-mp="18tg25oet4yhn">
      <div className="mx-auto max-w-2xl text-center" data-id="element-145" data-mp="1mlch0qrgtbw3">
        <h2 className="font-heading text-[1rem] font-bold uppercase leading-tight text-navy sm:text-[1.5rem]" data-id="element-146" data-mp="1hnknxtf33jqb">
          The Complete 6-in-1 Clinical Lab Visual System
        </h2>
        <p className="mt-0.5 font-heading text-[1.25rem] font-bold uppercase leading-tight text-clinical sm:text-[2rem]" data-id="element-147" data-mp="u02w5xvtklnc">
          🧪 Clinical Lab Visual Atlas™
        </p>
        <p className="mt-0.5 font-body text-[0.68rem] font-bold uppercase tracking-[0.1em] text-gold sm:text-xs" data-id="element-148" data-mp="13xqzvdbel3hn">
          Ready-to-use visual resources for clinical lab science
        </p>
        <p className="mt-0.5 text-[0.68rem] font-medium text-muted sm:text-[0.8rem]" data-id="element-149" data-mp="2fa1iws0chl8w">
          Hematology • Clinical Chemistry • Microbiology • Immunology •
          Urinalysis • Blood Bank
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-1.5 block" data-id="element-150" data-mp="235ukx78k977g">
          <img src={BOX_IMAGE} alt="The six modules of the CLINICAL LAB VISUAL ATLAS™ system" className="mx-auto w-full max-w-[210px] sm:max-w-[260px]" data-id="element-151" data-mp="284xqqtwd7hgh" />
        </a>

        <ul className="mt-1.5 grid grid-cols-1 gap-x-4 gap-y-0.5 text-left sm:grid-cols-2" data-id="element-152" data-mp="2i3wsdsipqctz">
          {systemChecklist.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-153" data-mp="1khpmmfaoaeg1">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-clinical" strokeWidth={3.5} aria-hidden="true" data-id="element-154" data-mp="1pg0xmtcpeuzu" />
              <span className="text-[0.8rem] leading-[1.35] text-ink sm:text-[0.95rem]" data-id="element-155" data-mp="1z5aqwcjaajpj">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}